import { render } from "./BasicUsage.vue?vue&type=template&id=e611fc10"
import script from "./BasicUsage.vue?vue&type=script&lang=js"
export * from "./BasicUsage.vue?vue&type=script&lang=js"
script.render = render

export default script